import React from 'react';
import { useMyUserId } from '../../../../../data/hooks/sessionHooks';
import getUserFromMeetingInvite from '../../../../../misc/getUserFromMeetingInvite';
import resolvePath from '../../../../../misc/resolvePath';
import Icon from '../../../../elements/icons/Icon';
import ProgramListItem from '../../../../elements/ProgramListItem/ProgramListItem';
import './MeetingInProgram.scss';
import { isMeetingPending } from 'common-data-handling';
import MeetingInProgramLocation from './MeetingInProgramLocation';
import PendingStatus from './PendingStatus';

const MeetingInProgram = (props) => {
    const { event, item: meeting, i18n } = props,
        myUserId = useMyUserId(),
        otherUser =
            meeting.initiator.id == myUserId
                ? meeting.invited.length == 1
                    ? getUserFromMeetingInvite(meeting.invited[0], i18n)
                    : {
                          first_name: i18n['button.group_invite'],
                          last_name: '',
                          image_url: null,
                      }
                : meeting.initiator,
        contentStyle = {
            color: event.settings.primary_color,
        },
        pending = isMeetingPending(meeting);

    function handleItemClicked() {
        const meetingPath = resolvePath(app.history.location.pathname, 'meeting', meeting.id.toString());
        console.log(meetingPath);
        app.history.push(meetingPath);
    }

    return (
        <ProgramListItem
            className={['MeetingInProgram', pending ? 'pending' : ''].join(' ')}
            startTime={meeting.start_local}
            endTime={meeting.end_local}
            nextIcon
            onClick={handleItemClicked}
            style={{
                borderBottomColor: event.settings.primary_color,
            }}
            contentStyle={contentStyle}
            selectableColor="white"
            tabIcon={<Icon className="vertical-center" src="/img/event_meetings.png" color={event.settings.primary_color} size={16} />}>
            <p className="title">{i18n['label.appointment']}</p>
            <p className="text name" style={contentStyle}>
                {otherUser.first_name} {otherUser.last_name}
            </p>
            {pending ? <PendingStatus meeting={meeting} style={contentStyle} /> : meeting.location ? <MeetingInProgramLocation meeting={meeting} style={contentStyle} /> : null}
        </ProgramListItem>
    );
};

export default MeetingInProgram;
